<!--
================================================
Vue affichant la page de maintenance de l'application

Limitation actuellement c'est MaintenanceComp qui détecte si le backend indique que l'app doit être en maintenance et qui transmet la date de retour via un query param à cette vue. à terme mutualiser l'info dans le store.


Url d'accès :
http://localhost:8080/fr/maintenance
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div slot="AppContent" id="MaintenanceView" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
      <br>
     <div class="columns is-centered">
       <div class="column is-6">
         <div class="box m-4 p-6">
           <img src="../assets/img/AppLogo.png" alt="Cronocloud App" width="164" height="29" class="mb-4">

           <img
               class=" m-auto is-block"
               src="../assets/img/illustrations/UnderConstruction-amico.svg"
               alt="illustration"
               height="220px"
               width="220px"/>

           <h1 class="is-size-6 mt-4">{{ $t('LApplicationEstActuellementInaccessiblePourCauseDeMaintenance') }}</h1>
           <p v-if="returnDate!=null" class="returnDate has-text-grey-light">{{ $t('retourPrévuLe', {"date": returnDate}) }}</p>
         </div>
       </div>
     </div>

    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
import VueMetaMixin from "../mixins/VueMetaMixin.js";
import InterceptorMixin from "../mixins/InterceptorMixin.js";
import {mapState} from "vuex";
import OutdoorLayoutComp from "@/components/OutdoorLayoutComp";

export default {
  name: 'MaintenanceView',
  data: function () {
    return {
      locale: this.$route.params.locale,
    }
  },
  computed: {
    // computed props for store :
    ...mapState({
      themeToDisplay: state => state.app.themeToDisplay
    }),

    //----------------------------------------------

    returnDate: {
        get: function () {
          if(this.$route.query.returnDate !=null){
            return this.$moment(this.$route.query.returnDate, "'DD-MM-YYYY hh:mm'").format("lll")
          }
        },
    }

  },

  components: {
    OutdoorLayoutComp,
  },
  mixins: [VueMetaMixin, InterceptorMixin],
  //==========================================================
  metaInfo() {
    return this.setMeta(this.$t("metaTitleDefault"), this.$t("metaDescDefault"))
  },
  //==========================================================
  methods: {},
  created: function () {
  },
}
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
/*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">
@import "../assets/css/globalVar.scss";
/*@import "../assets/css/bulmaResponsiveDep.scss";*/

#MaintenanceView {
  background: $brandThird;
  background-image:
      url('../assets/img/comingsoonBg8bit.png'),
      linear-gradient(to right top, #1d3034, #2a454b, #385c64, #46747d, #558c98);
  background-size: cover;
  min-height: 100vh;

  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////


  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {
  }

}
</style>
